module.exports = {
  domain: {
    desktop: "4njbets.int.use2.racing.fndlext.net",
    mobile: "4njbets.int.use2.racing.fndlext.net",
    talentPicks: "4njbets.int.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store-qa.us.betfair.com"
  },
  service_host: "service.4njbets.int.use2.racing.fndlext.net",
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
